/* 
Object:         Addressbook
Description:    Logic and events for the module Addressbook
Used in:        Addressbook
*/

import { ModuleActionViewEnum } from '../enums/moduleActionViewEnum';

import * as appsettings from '../appsettings';
import * as dialog from '../dialog';
import * as navigation from '../navigation';
import * as viewmode from '../viewmode';

/**
 * Delete item from grid
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    let event = e;
    let data = this;

    /**
     * JQuery.Event = basis event type (van jQuery) & { currentTarget: HTMLElement } = ik garandeer / override dat currentTarget een HTMLElement is
     */ 
    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {

        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as AddressbookItemVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Addressbook/Delete?addressId=" + dataItem.AddressID),
            success: function () {
                // Refresh datasource grid 
                $("#AddressbookGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * Update a item from grid
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as AddressbookItemVM;

    // Label
    const label: string | null = dataItem.Name;
    const addressId: number = dataItem.AddressID;

    // Edit mode Form 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Addressbook/Edit?addressId=" + addressId + "&breadcrumbLabel=" + label);
}

/**
 * Show item from grid
 */
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as AddressbookItemVM;
    
    // Label
    const label: string | null = dataItem.Name;
    const addressId: number = dataItem.AddressID;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Addressbook/Show?addressId=" + addressId + "&breadcrumbLabel=" + label);
}
